import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { VexRoutes } from '../../../@vex/interfaces/vex-route.interface';
import { QuicklinkModule } from 'ngx-quicklink';
import { ExpirationDateComponent } from './expiration-date.component';

const routes: VexRoutes = [
  {
    path: '',
    component: ExpirationDateComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class ExpirationDateRoutingModule {
}
